import type { FetchClientMiddleware } from '@foundatiofx/fetchclient';
import { error } from '@sveltejs/kit';

const KEY = 'apiRequestTimes';

function recentTimes(storage: Storage, windowStart: number): number[] {
    try {
        return (JSON.parse(storage.getItem(KEY) ?? '[]') as number[]).filter((t) => t > windowStart);
    } catch {
        return [];
    }
}

function saveTimes(storage: Storage, times: number[]) {
    try {
        storage.setItem(KEY, JSON.stringify(times));
    } catch {
        storage.removeItem(KEY);
    }
}

export function tabRequestBudget(
    maxRequests: number,
    windowSeconds: number,
    storage: Storage | undefined = typeof sessionStorage === 'undefined' ? undefined : sessionStorage
): FetchClientMiddleware {
    return async (_ctx, next) => {
        if (storage) {
            const now = Date.now();
            const times = recentTimes(storage, now - windowSeconds * 1000);
            if (times.length >= maxRequests)
                error(429, 'This tab is sending too many requests. Wait a minute, then reload the page.');

            times.push(now);
            saveTimes(storage, times);
        }

        await next();
    };
}
